import { render, staticRenderFns } from "./MenuQuotation.vue?vue&type=template&id=23414902&scoped=true&"
import script from "./MenuQuotation.vue?vue&type=script&lang=js&"
export * from "./MenuQuotation.vue?vue&type=script&lang=js&"
import style0 from "./MenuQuotation.vue?vue&type=style&index=0&id=23414902&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23414902",
  null
  
)

export default component.exports